import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "login.title",
    },
    email: {
        id: "account.email",
    },
    password: {
        id: "account.password",
    },
    submit: {
        id: "login.submit",
    },
    facebookButton: {
        id: "login.facebook.button",
    },
    facebookInProgress: {
        id: "login.facebook.inProgress",
    },
    googleButton: {
        id: "login.google.button",
    },
    remindPassword: {
        id: "login.remindPassword",
    },
    withEmail: {
        id: "signup.withEmail",
    },
    withSocial: {
        id: "signup.withSocial",
    },
    signup: {
        id: "signup.submit",
    },
});

export default messages;
